import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ScrollWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  overflowX: 'hidden',
  overflowY: 'auto',
}));
